// src/pages/Community/Location/LocationDetailPanel.jsx
import React, { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../../firebase";
import LocationDetailContent from "./LocationDetailContent";

export default function LocationDetailPanel({ locationId, onClose, user }) {
    const [loc, setLoc] = useState(null);
    const [selectedReactionFromBar, setSelectedReactionFromBar] = useState(null);
    useEffect(() => {
        if (!locationId) return;

        return onSnapshot(doc(db, "locations", locationId), (snap) => {
            setLoc(snap.exists() ? { id: snap.id, ...snap.data() } : null);
        });
    }, [locationId]);

    if (!locationId) {
        return <div style={{ padding: 16 }}>Select a location</div>;
    }

    if (!loc) {
        return <div style={{ padding: 16 }}>Loading…</div>;
    }

    const isOwner =
        !!user?.uid &&
        (loc.createdBy === user.uid || loc.authorUid === user.uid);

    return (
        <div className="msn-panel-body">
            {/* SCROLLABLE CONTENT */}
            <LocationDetailContent
                loc={loc}
                uid={user?.uid}
                isOwner={isOwner}

                presenceKey="locations"
                locationId={loc.id}
                basePath={["locations", loc.id]}
                bookmarkKey={`locations:${loc.id}`}

                selectedReactionFromBar={selectedReactionFromBar}
                onReactionSelect={(id) => setSelectedReactionFromBar(id)}

                renderHeader
                renderEngagement
                renderDiscussion
            />


        </div>
    );
}
